export enum AppIds {
  PersonalArea = 'react-personal-area',
  HeaderApp = 'react-header-app',
  SidebarApp = 'react-sidebar-app',
  Footer = 'react-footer',
  BottomNav = 'react-bottom-nav',
}
